import * as React from 'react';
import { Button, DropdownButton } from '../bootstrap-components/BootstrapComponents';
import { Anchor } from '../layout/Anchor';
import { Icon } from '../Icon';
import { Section } from '../layout/Section';

interface ButtonProps { url: string; text: string; className?: string; disabled?: boolean; }
export function LinkPrimaryButton(props: ButtonProps) {
    return (
        <Anchor href={props.url}>
            <Button buttonType='primary' className={props.className} disabled={props.disabled}>{props.text}</Button>
        </Anchor>
    );
}

export function LinkSecondaryButton(props: ButtonProps) {
    return (
        <Anchor href={props.url}>
            <Button buttonType='secondary' className={props.className} disabled={props.disabled}>{props.text}</Button>
        </Anchor>
    );
}

export function LinkSectionButton(props: ButtonProps) {
    const emblaArrowRightIcon = (
        <Icon name={'arrow-right'} />
    );

    return (
        <Section fullWidth={true} className={props.className}>
            <Anchor href={props.url}>
                <Button buttonType='section' disabled={props.disabled}>
                    {props.text} <span>{emblaArrowRightIcon}</span>
                </Button>
            </Anchor>
        </Section>
    );
}

interface DeleteButtonProps { id?: string; buttonOnClick: (key: any) => void; className?: string; }
export function RoundDeleteBtn(props: DeleteButtonProps) {
    let classes = 'remove-icon';
    if (props.className !== undefined) {
        classes += ' ' + props.className;
    }

    return (
        <RoundBtn id={props.id} buttonOnClick={props.buttonOnClick} className={classes} iconName='close' />
    );
}

interface RoundBtnProps { id?: string; buttonOnClick: (key: any) => void; className?: string; iconName: string; }
export function RoundBtn(props: RoundBtnProps) {
    let classes = 'round-btn';
    if (props.className !== undefined) {
        classes += ' ' + props.className;
    }

    return (
        <div id={props.id} className={classes} onClick={props.buttonOnClick}>
            <Icon className='icon' name={props.iconName} />
        </div>
    );
}

interface RoundLinkProps {
    id?: string;
    href: string;
    className?: string;
    iconName: string;
    tooltip?: string;
    tooltipPlacement?: string;
}
export function RoundLink(props: RoundLinkProps) {
    let classes = 'round-btn round-link';
    if (props.className !== undefined) {
        classes += ' ' + props.className;
    }

    if (props.tooltip !== undefined && props.tooltip.length > 0) {
        classes += ' nvhus-tooltip';
        let tooltipPlacement = props.tooltipPlacement !== undefined && props.tooltipPlacement.length > 0 ? props.tooltipPlacement : 'top';

        return (
            <div id={props.id} className={classes} data-toggle='tooltip' data-placement={tooltipPlacement} title={props.tooltip}>
                <Anchor href={props.href}>
                    <Icon className='icon' name={props.iconName} />
                </Anchor>
            </div>
        );
    }

    return (
        <div id={props.id} className={classes}>
            <Anchor href={props.href}>
                <Icon className='icon' name={props.iconName} />
            </Anchor>
        </div>
    );
}

interface AddContentButtonProps { text: string; buttonOnClick: (key: any) => void; }
export function AddContentButton(props: AddContentButtonProps) {
    return (
        <Button buttonType='secondary' className={'addContentBtn'} onClick={props.buttonOnClick}>{props.text}</Button>
    );
}

interface OverflowDropdownButtonProps {
    children?: any;
}
export function OverflowDropdownButton(props: OverflowDropdownButtonProps) {
    const emblaOverflowIcon = (
        <Icon name={'overflow'} />
    );

    return (
        <DropdownButton className='overflow-dropdown-btn dropdown-menu-right' buttonSize='md' buttonType='transparent' noCaret={true} title={emblaOverflowIcon} >
            {props.children}
        </DropdownButton>
    );
}
interface PrintButtonProps {
    text: string;
}
export const PrintButton = (props: PrintButtonProps) => (<div className='print-button'><Button onClick={window.print} buttonType='secondary'>{props.text}</Button></div>);


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/input/Buttons.tsx